import { render, staticRenderFns } from "./working-as-an-interior-designer.vue?vue&type=template&id=448af635&scoped=true&"
import script from "./working-as-an-interior-designer.vue?vue&type=script&lang=js&"
export * from "./working-as-an-interior-designer.vue?vue&type=script&lang=js&"
import style0 from "./working-as-an-interior-designer.vue?vue&type=style&index=0&id=448af635&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "448af635",
  null
  
)

export default component.exports